import { useNavigate, useRouteError } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import Header from "@/component/header";
import { Button } from "@nextui-org/react";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { IconChevronDown } from "@tabler/icons-react";

Component.displayName = "ErrorPage";

export default function Component() {
  const error = useRouteError() as Error;
  const navigate = useNavigate();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="flex min-h-svh">
      <div className="flex-auto pb-16 max-h-svh overflow-y-scroll md:pb-4 relative">
        <div className="sticky top-0 bg-default-555 z-40 pt-1">
          <Header title="发生意外" />
        </div>
        <div className="mx-auto w-full max-w-md px-4 pt-1 flex flex-col gap-4 mb-20 text-left">
          <Disclosure
            as="div"
            className="p-2 bg-default-200/20 rounded-md"
            defaultOpen={false}
          >
            <DisclosureButton className="group flex w-full items-center justify-between">
              <div className="text-left text-sm/6 font-bold text-bl">
                对不起，发生了一个错误： {error.message}
              </div>
              <IconChevronDown className="size-5 group-data-[open]:rotate-180" />
            </DisclosureButton>
            <DisclosurePanel className="mt-2 text-sm/5 ">
              <code className=" whitespace-pre-wrap break-all text-xs">
                {error.stack}
              </code>
            </DisclosurePanel>
          </Disclosure>
          <Button
            color="warning"
            onPress={() => {
              Sentry.showReportDialog({ eventId: Sentry.lastEventId() });
            }}
            radius="sm"
          >
            上报问题
          </Button>
          <Button
            color="warning"
            onPress={() => {
              navigate(-1);
            }}
            radius="sm"
          >
            返回
          </Button>
        </div>
      </div>
    </div>
  );
}
